/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Setup state of a survey replacing a previous edition within the survey season.
 */
export enum SurveySeasonSurveySetupStatus {
    DONE = 'done',
    READY_TO_SET_UP = 'readyToSetUp',
    AWAITING_DATA_UPLOAD = 'awaitingDataUpload',
    IN_PROGRESS = 'inProgress',
}
